module.exports = __webpack_public_path__ + "shopping_white.c77c7137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/white/shopping_white.png
// module id = 934
// module chunks = 0